import { render, staticRenderFns } from "./ContasReceberValorTituloVencidosVinteDias.vue?vue&type=template&id=1c5ca0ad&scoped=true&"
import script from "./ContasReceberValorTituloVencidosVinteDias.vue?vue&type=script&lang=js&"
export * from "./ContasReceberValorTituloVencidosVinteDias.vue?vue&type=script&lang=js&"
import style0 from "./ContasReceberValorTituloVencidosVinteDias.vue?vue&type=style&index=0&id=1c5ca0ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ca0ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
